import { PageTileHeader } from '@block-explorer/ui';
import React from 'react';
import { FlexRow, FlexRowProps } from '@make-software/cspr-design';

interface TileSideHeaderProps extends Pick<FlexRowProps, 'justify'> {
  title: string | React.ReactNode;
  icon?: React.ReactNode;
}

export function TileSideHeader({ title, icon, justify }: TileSideHeaderProps) {
  return (
    <PageTileHeader scale={'xl'} tag={'h3'}>
      <FlexRow gap={16} align={'center'} justify={justify}>
        {title}
        {icon}
      </FlexRow>
    </PageTileHeader>
  );
}

export default TileSideHeader;
